import Paper from "@mui/material/Paper/Paper";
import Grid from "@mui/material/Grid/Grid";
import Box from "@mui/material/Box/Box";
// import PROJECT1 from "../../assets/images/project_1.png";
import {
    CustomLabelRegularMedium,
    CustomLabelSmallBold,
    CustomLabelSmallMedium,
    CustomLabelXSmallRegular
} from "../common/CustomLabel";
import React from "react";
// import ARROW_UP from "../../assets/images/arrow-up-right.png";
import NorthEastIcon from '@mui/icons-material/NorthEast';

const WorkCard = ({title, description, tags, img, date,issued_by, type,onClick}) => {


    return (

        <>
            {
                !type &&
                (
                    <Paper sx={{
                        width: "100%",
                        marginBottom: "10px",
                        background: "#FAF7FF",
                        borderRadius: "25px",
                    }}>
                        <Grid item container alignItems={"center"} direction={"column"}
                              sx={{padding: {xs: "15px", sm: "20px", md: "20px 20px"}}}>
                            <Grid item sx={{width: {xs: "100%", sm: "100%"}}}>
                                <Box component={"img"} src={img} alt={title} sx={{
                                    width: "100%",
                                    minHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    maxHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    borderRadius: "10px"
                                }}/>
                            </Grid>
                            <Grid item sx={{padding: {xs: "10px 10px", md: "12px 16px"}}} container>
                                <CustomLabelSmallBold text={title}/>
                            </Grid>
                            <Grid item container
                                  sx={{padding: {xs: "0px 10px", md: "0px 16px"}, marginTop: "-5px"}}>
                                <CustomLabelRegularMedium
                                    text={description}
                                    color={"#A3A3A3"}
                                    normal={false}
                                />
                            </Grid>
                            <Grid item container justifyContent={"space-between"}
                                  sx={{padding: {xs: "0px 10px 10px 10px", md: "0px 16px 16px 16px"}}}>

                                {
                                    tags.map((t) =>
                                        <Grid item sx={{
                                            background: "white",
                                            padding: {xs: "5px", md: "10px"},
                                            borderRadius: 16,
                                            marginTop: {xs: "10px", md: "16px"}
                                        }}>
                                            <CustomLabelXSmallRegular text={t}/>
                                        </Grid>
                                    )
                                }

                            </Grid>
                        </Grid>
                    </Paper>
                )
            }

            {
                type == 1 &&
                (
                    <Paper
                        onClick={onClick}
                        elevation={0}
                        sx={{
                            width: "100%",
                            marginBottom: "10px",
                            background: "#FAF7FF",
                            borderRadius: "25px",
                            height:"100%",
                            cursor:"pointer"
                        }}>
                        <Grid item container alignItems={"center"} direction={"column"} sx={{padding:"8px"}}>
                            <Grid item sx={{width: {xs: "100%", sm: "100%"}}}>
                                <Box component={"img"} src={img} alt={title} sx={{
                                    width: "100%",
                                    minHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    maxHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    borderRadius: "10px"
                                }}/>
                            </Grid>
                            <Grid item container
                                  sx={{padding: {xs: "0px 12px"},marginTop:"5px"}}>
                                <CustomLabelXSmallRegular
                                    text={date}
                                    color={"#333333"}
                                    normal={true}
                                />
                            </Grid>

                            <Grid item sx={{padding: {xs: "0px 12px"},marginTop:"5px"}} container>
                                <CustomLabelSmallBold color={"#333333"} style={{lineHeight:1.2}} text={title}/>
                            </Grid>
                            <Grid item container
                                  sx={{padding: {xs: "0px 12px"}, marginTop:"20px"}}>
                                <CustomLabelRegularMedium
                                    text={description}
                                    color={"#333333"}
                                    normal={true}
                                    textAlign={"left"}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                )
            }


            {
                type == 2 &&
                (
                    <Paper

                        elevation={0}
                        sx={{
                            width: "100%",
                            marginBottom: "10px",
                            background: "#FAF7FF",
                            borderRadius: "25px",
                            height:"100%"
                        }}>
                        <Grid item container alignItems={"center"} direction={"column"} sx={{padding:"8px"}}>
                            <Grid item sx={{width: {xs: "100%", sm: "100%"}}}>
                                <Box component={"img"} src={img} alt={title} sx={{
                                    width: "100%",
                                    minHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    maxHeight: {xs: "280px", sm: "400px", md: "282px", lg: "320px"},
                                    borderRadius: "10px"
                                }}/>
                            </Grid>
                            <Grid item container
                                  sx={{padding: {xs: "0px 12px"},marginTop:"10px"}}>
                                <CustomLabelXSmallRegular
                                    text={issued_by}
                                    color={"#333333"}
                                    normal={true}
                                />
                            </Grid>

                            <Grid item sx={{padding: {xs: "0px 12px"},marginTop:"10px"}} container>
                                <CustomLabelSmallBold color={"#333333"} style={{lineHeight:1.2}} text={title}/>
                            </Grid>
                            <Grid item container
                                  sx={{padding: {xs: "0px 12px"},marginTop:"10px"}}>
                                <CustomLabelRegularMedium
                                    text={description}
                                    color={"#333333"}
                                    normal={true}
                                    lineHeight={1.2}
                                />
                            </Grid>



                            <Grid item xs={12} container>

                                <Grid item container sx={{
                                    border: "1.5px solid #DDDDDD",
                                    borderRadius: "20px",
                                    width:"100%",
                                    background: "#FFFFFF", marginTop: "20px",
                                    padding:"16px 0px"
                                }}
                                      alignItems={"center"} justifyContent={"center"}>

                                    <Grid item>
                                        <CustomLabelSmallMedium
                                            fontWeight={"bold"}
                                            text={"View Certificate"} color={"#5E17EB"}/>
                                    </Grid>

                                    <Grid item style={{marginLeft: "10px"}}>
                                        <NorthEastIcon color={"#5E17EB"} sx={{color:"#5E17EB"}}/>
                                    </Grid>

                                </Grid>

                            </Grid>


                        </Grid>
                    </Paper>
                )
            }

        </>
    )
}


export default WorkCard;
